:host {
    @include typo-ws-paragraph;

    color: var(--link-color, $color-red);
    display: block;
    position: relative;

    ::slotted(button) {
        all: unset;
    }

    ::slotted(a),
    ::slotted(button) {
        display: block;
        padding-left: clamp(26px, 1.806vw, 30px);
        text-decoration: none;
        color: currentColor;
    }

    ::slotted(.size) {
        @include typo-ws-paragraph-s;

        margin: 0 0 #{generate-clamp(2, 3)} 10px;
        color: $color-grey-01-dark;
        align-self: flex-end;
    }

    ::slotted(sew-ws-tooltip) {
        display: none !important;
    }

    span {
        position: relative;
        display: flex;
    }

    .svg {
        left: 0;
        position: absolute;
        top: clamp(2px, 0.139vw, 4px);

        --svg-width: clamp(20px, 1.389vw, 22.5px) !important;

        .shaft {
            opacity: 0;
            transition: opacity 0.2s;
        }
    }
}

:host(:hover) {
    color: var(--link-color, $color-red);
}

:host(.stack-up) {
    z-index: 1;
}

:host([type='default']) {
    left: var(--offset, 0);

    span {
        transform: translate3d(-10px, 0, 0);
        transition: transform 0.2s;
    }
}

:host([type='default']:hover),
:host([type='anchor']:hover) {
    .svg {
        .shaft {
            opacity: 1;
        }
    }
}

:host([type='default']:hover) {
    span {
        transform: translate3d(-4px, 0, 0);
    }
}

:host([type='external']),
:host([type='download']),
:host([type='protected']),
:host([type='anchor']) {
    .svg {
        top: generate-clamp(2, 3);
        left: -2px;
    }

    ::slotted(a) {
        padding-left: clamp(19px, 1.319vw, 22px);
        transition: transform 0.2s;
    }

    ::slotted(span) {
        transition: transform 0.2s;
    }
}

:host([type='external']:hover),
:host([type='download']:hover) {
    ::slotted(a),
    ::slotted(span) {
        transform: translate3d(8px, 0, 0);
    }
}

:host([type='external']) {
    .arrow {
        transition: transform 0.2s;
    }
    ::slotted(a) {
        padding-left: clamp(22px, 1.528vw, 25px);
    }
}

:host([type='external']:hover) {
    .arrow {
        transform: translate(2px, -2px);
    }
}

@keyframes download-animation {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-3px);
    }
    100% {
        transform: translateY(0);
    }
}
:host([type='download']:hover) {
    .arrow {
        animation: download-animation 0.5s;
    }
}

:host([type='anchor']) {
    .svg {
        top: 0;
        transform: translate3d(0, 0, 0);
        transition: transform 0.2s;
    }
}

:host([type='anchor']:hover) {
    .svg {
        transform: translate3d(0, 4px, 0);
    }
}

:host([type='back']) {
    ::slotted(button) {
        padding-left: 16px;
    }
}

:host([size='large']) {
    @include typo-ws-copy-l;

    color: var(--link-color, $color-grey-01-dark);

    ::slotted(a) {
        padding-left: generate-clamp(20, 36);
    }

    .svg {
        --svg-width: #{generate-clamp(20, 36)} !important;

        top: generate-clamp(3, 5);
        left: generate-negative-clamp(-4, -7);
    }
}

:host([size='large'][type='default']) {
    span {
        transform: translate3d(generate-negative-clamp(-4.4, -8), 0, 0);
    }
}

:host([size='large'][type='default']:hover) {
    color: var(--link-color, $color-red);

    span {
        transform: translate3d(2px, 0, 0);
    }
}

:host([size='xl']) {
    @include typo-ws-copy-xl;

    color: $color-grey-01-dark;

    ::slotted(a) {
        padding-left: generate-clamp(20, 36);
    }

    .svg {
        --svg-width: #{generate-clamp(20, 36)} !important;

        top: generate-clamp(6, 10);
        left: generate-negative-clamp(-4.3, -9);
    }
}

:host([size='xl'][type='default']) {
    span {
        transform: translate3d(generate-negative-clamp(-4.3, -8), 0, 0);
    }
}

:host([size='xl'][type='default']:hover) {
    color: $color-red;

    span {
        transform: translate3d(3px, 0, 0);
    }
}

:host([size='bold']) {
    @include typo-ws-paragraph-bold;
}

:host([os]) {
    color: var(--color-text-default);

    ::slotted(sew-ws-tooltip) {
        margin-left: 8px;

        @include mq-2-min {
            display: none !important;
        }
    }
}

:host([os]:hover) {
    color: $color-red;

    ::slotted(sew-ws-tooltip) {
        display: inline-block !important;
    }
}
